import { render, staticRenderFns } from "./advertising-analysis.vue?vue&type=template&id=29c92ad3&scoped=true&"
import script from "./advertising-analysis.vue?vue&type=script&lang=js&"
export * from "./advertising-analysis.vue?vue&type=script&lang=js&"
import style0 from "./advertising-analysis.vue?vue&type=style&index=0&id=29c92ad3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c92ad3",
  null
  
)

export default component.exports